import React from 'react';
import PropTypes from 'prop-types';
import Link from "../components/Application/Link";
import uuid from "react-native-uuid";
import {Modal, ModalBody, ModalHeader, Popover, PopoverBody, PopoverHeader} from "reactstrap";
import {isDesktop} from "react-device-detect";
import Icon from "./Icon";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import {isEmpty} from "lodash";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import classnames from "classnames";

const ObjectLinkWithDetails = props => {
  const { t } = useTranslation('object_link_with_details')
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleIsOpen = () => setIsOpen(!isOpen)
  const [uid, setUid] = React.useState('t' + uuid.v4())

  useAfterUpdateEffect(() => {
    if(isOpen && isEmpty(props.objectData)){
      props.getObjectData()
    }
  }, [isOpen])

  const getBody = () => {
    if(isEmpty(props.objectData)){
      return <div className="text-center" style={{width: 250}}>
        <LoadingSpinner padding={0} />
      </div>
    }

    return props.objectData.body()
  }

  return <>
    <div className={classnames({
      'text-truncate': !props.textTruncateAutoWidth,
      'text-truncate-auto-width': props.textTruncateAutoWidth,
      [props.className ?? '']: true,
    })}>
      <Link to={props.link} id={uid} disableRedirect={props.disableRedirect} className="d-block text-ellipsis">
        <Icon className={`${props.linkText ? 'mr-2' : ''} ${props.icon}`} onClick={e => {
          if(!props.disableDetails){
            e.preventDefault()
            toggleIsOpen()
          }
          if(!props.disableRedirect){
            e.stopPropagation()
          }
        }} />
        <span>{props.linkText}</span>
      </Link>
    </div>
    {
      !props.disableDetails && (
        isDesktop
          ? <Popover
            isOpen={isOpen}
            boundariesElement={document.body}
            delay={450}
            fade={false}
            trigger="hover"
            placement="right-start"
            target={uid}
            toggle={toggleIsOpen}
            onClick={e => e.stopPropagation()}
          >
            {({scheduleUpdate}) => <>
              {props.objectData && <PopoverHeader className="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                <Link to={props.link} className="text-white font-weight-bold d-flex flex-row flex-nowrap justify-content-between align-items-center" target="_blank" tooltip={t('open_in_new_tab')}>
                  <span>{props.objectData.title}</span>
                  <small className="fas fa-external-link-alt ml-1 text-secondary"/>
                </Link>
                <div className="ml-3">
                  <CopyToClipboard text={props.linkText} onCopy={() => toast.success(t('copied'))}>
                    <Icon className="fas fa-copy text-white cursor-pointer" tooltip={t('click_to_copy')} />
                  </CopyToClipboard>
                </div>
              </PopoverHeader>}
              <PopoverBody>
                {scheduleUpdate()}
                {getBody()}
              </PopoverBody>
            </>}
          </Popover>
          : <Modal isOpen={isOpen} toggle={toggleIsOpen}>
            <ModalHeader toggle={toggleIsOpen}>
              {props.objectData && <Link to={props.link} className="font-weight-bold d-flex flex-row flex-nowrap align-items-center" target="_blank" tooltip={isDesktop && t('open_in_new_tab')}>
                <span>{props.objectData.title}</span>
                <small className="fas fa-external-link-alt ml-1 text-secondary" />
              </Link>}
            </ModalHeader>
            {isOpen && <ModalBody>
              {getBody()}
            </ModalBody>}
          </Modal>
      )
    }
  </>
};

ObjectLinkWithDetails.defaultProps = {
  disableDetails: false,
  disableRedirect: false,
  textTruncateAutoWidth: true,
};

ObjectLinkWithDetails.propTypes = {
  textTruncateAutoWidth: PropTypes.bool,
  getObjectData: PropTypes.func.isRequired,
  objectData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.func.isRequired,
  }),
  disableDetails: PropTypes.bool,
  disableRedirect: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  link: PropTypes.string.isRequired,
};

export default ObjectLinkWithDetails;